import { A11yModule } from "@angular/cdk/a11y";
import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { CoreModule } from "@modules/core/core.module";
import { Web3MigrationRoutes } from "@modules/web3/w3st-migration.module";
import { WEB3_MERGE_PHASE, Web3Facade, Web3TrackingEventNames } from "@modules/web3/+state/web3.facade";
import { Web3NavigationService } from "@modules/web3/services/web3.navigation";
import { take, tap } from "rxjs";

@Component({
	selector: "web3-auto-migration-intro-component",
	imports: [CoreModule, UniversalModalModule, A11yModule],
	templateUrl: "./web3-auto-migration-intro.component.component.html",
	styleUrl: "./web3-auto-migration-intro.component.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Web3AutoMigrationIntroComponentComponent implements OnInit {
	private facade = inject(Web3Facade);
	private navigation = inject(Web3NavigationService);

	migrationFF$ = this.facade.getMergePhase();
	holdsBestOrPan$ = this.facade.userHoldsBestOrPan().pipe(tap((holdsBestPan) => (this.holdsBestPan = holdsBestPan)));
	//holdsVision$ = this.facade.userHoldsVision().pipe(tap((holdsVision) => (this.holdsVision = holdsVision)));

	phase = WEB3_MERGE_PHASE;
	currentPhase: WEB3_MERGE_PHASE;
	holdsBestPan = false;
	//holdsVision = false;

	public ngOnInit(): void {
		this.facade
			.getMergePhase()
			.pipe(
				take(1),
				tap(({ phase }) => (this.currentPhase = phase))
			)
			.subscribe((mergePhase) => {
				this.facade.trackEvent(Web3TrackingEventNames.MigrationIntroScreenViewed, {
					phase: mergePhase.phase
				});
			});
	}

	next(): void {
		if (
			(this.currentPhase === this.phase.PostMerge || this.currentPhase === this.phase.PreMerge) &&
			this.holdsBestPan
		) {
			this.navigation.gotoWeb3ByUrl(Web3MigrationRoutes.autoMigrationSignup);
			return;
		}
		this.navigation.closeModal();
		this.navigation.gotoByPath("my-vision");
		return;
	}

	learnMore(): void {
		this.navigation.closeModal();
		this.navigation.gotoByPath("my-vision");
	}
}
